import { createAsyncThunk } from '@reduxjs/toolkit';
import { IThunkApi } from 'shared/types/redux';
import { selectDirectionsModal } from 'shared/selectors/geo';
import { selectLocation } from 'shared/selectors/location';
import { getRegionIdForDirections } from 'shared/utils/geo';
import {
  fetchApiGeoGetRoads,
  TApiGeoGetRoadsResponse,
} from 'shared/repositories/monolith-cian-realty/api/geo/get-roads';
import { IDirection } from 'shared/types/geo';
import { IRequestDirectionsDataPayload } from 'shared/slices/geo/types';
import { setDirections } from 'shared/slices/tags';

interface IThunkApiExtended extends IThunkApi {
  rejectValue: void;
}

export const loadDirectionsData = createAsyncThunk<IRequestDirectionsDataPayload, void, IThunkApiExtended>(
  'geo/directionsModal/loadData',
  async (_, { getState, extra: context, dispatch, rejectWithValue }) => {
    const state = getState();
    const directionsModal = selectDirectionsModal(state);
    const currentLocation = selectLocation(state);
    const regionId = getRegionIdForDirections(currentLocation);

    // В store уже лежат данные для этого региона
    if (regionId === directionsModal.regionId && directionsModal.data && directionsModal.data.length) {
      return {
        directionsData: directionsModal.data,
        regionId,
      };
    }

    try {
      const { response } = await fetchApiGeoGetRoads<TApiGeoGetRoadsResponse>({
        httpApi: context.httpApi,
        parameters: { regionId },
        config: {
          subdomain: context.custom.subdomain,
        },
      });

      const directionsData = response as IDirection[];

      dispatch(setDirections(directionsData));

      return {
        directionsData,
        regionId,
      };
    } catch (e) {
      return rejectWithValue();
    }
  },
);
